<div class="databox-header">
  <span class="t-data-label"><ng-content select="[title]" /></span><ng-content select="[action]" />
</div>
<p class="t-data"><ng-content /></p>
